import { render, staticRenderFns } from "./EvEpochDashboard.vue?vue&type=template&id=2006c35e&scoped=true"
import script from "./EvEpochDashboard.vue?vue&type=script&lang=js"
export * from "./EvEpochDashboard.vue?vue&type=script&lang=js"
import style0 from "./EvEpochDashboard.vue?vue&type=style&index=0&id=2006c35e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006c35e",
  null
  
)

export default component.exports